module.exports = __webpack_public_path__ + "static/media/driverless-car.60de57c5.png";